export default function showActivitiesTimelinePopup(prefix) {
  const data = this.dataGet(prefix);
  const params = this.activitiesTimeLineParams(data);
}
